module.exports = __webpack_public_path__ + "0ee2b1fd896959aa6cd565eefdd43020.MP3";